import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import {
  Collapse,
  NavbarBrand,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
} from 'reactstrap';
import NavItems from './NavItem';
import styles from './Sidebar.module.scss';
import classNames from 'classnames';
import { FiChevronsLeft } from 'react-icons/fi';
import CollapsedLogo from '@assets/img/brand/logo2.jpeg';
export const SidebarComponent = ({ logo }) => {
  const [collapseOpen, setCollapseOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const handleSidebarCollapse = () => {
    setIsSidebarCollapsed((prev) => {
      const newValue = !prev;
      // Read the same --sidebar-width-* custom properties the SCSS uses
      // (src/styles/colors.scss) instead of duplicating the pixel values
      // here, so the sidebar and the main content it offsets can't drift
      // out of sync with each other or with the CSS.
      const rootStyle = getComputedStyle(document.documentElement);
      const width = rootStyle
        .getPropertyValue(
          newValue ? '--sidebar-width-collapsed' : '--sidebar-width-expanded'
        )
        .trim();
      document.getElementById('main_portal_target').style.marginLeft = width;
      document.getElementById('sidenav-main').style.maxWidth = width;

      return newValue;
    });
  };
  const toggleCollapse = () => {
    setCollapseOpen((prev) => !prev);
  };

  const closeCollapse = () => {
    setCollapseOpen(false);
  };

  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link,
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: '_blank',
    };
  }
  return (
    <Navbar
      className={classNames(
        styles.sidebar,
        { [styles.sidebar_collapsed]: isSidebarCollapsed },
        'navbar-vertical fixed-left navbar-light'
      )}
      expand="md"
      id="sidenav-main"
      style={{ transition: 'max-width 0.3s ease' }}
    >
      <Container fluid className={styles.sidebarInner}>
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleCollapse}
        >
          <span className="navbar-toggler-icon" />
        </button>
        {logo ? (
          <NavbarBrand
            className={styles.sidebarLogoContainer}
            {...navbarBrandProps}
          >
            {isSidebarCollapsed ? (
              <img
                src={CollapsedLogo}
                alt={logo.imgAlt}
                className={styles.collapsedLogo}
              />
            ) : (
              <img
                style={{ maxWidth: '150px' }}
                src={logo.imgSrc}
                alt={logo.imgAlt}
                className={styles.imgSrc}
              />
            )}
            <button
              type="button"
              className={styles.sidebarCollapseButton}
              onClick={(event) => {
                // NavbarBrand renders as the logo's <Link> when it has an
                // innerLink — stop the click from also bubbling into a
                // navigation.
                event.preventDefault();
                event.stopPropagation();
                handleSidebarCollapse();
              }}
              aria-label={
                isSidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'
              }
            >
              <FiChevronsLeft
                size={16}
                className={classNames(styles.sidebarCollapseIcon, {
                  [styles.sidebarCollapseIcon_rotated]: isSidebarCollapsed,
                })}
              />
            </button>
          </NavbarBrand>
        ) : null}
        <Collapse navbar isOpen={collapseOpen}>
          <div className="navbar-collapse-header d-md-none">
            <Row>
              {logo ? (
                <Col className="collapse-brand" xs="6">
                  {logo.innerLink ? (
                    <Link to={logo.innerLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </Link>
                  ) : (
                    <a href={logo.outterLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </a>
                  )}
                </Col>
              ) : null}
              <Col className="collapse-close" xs="6">
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={toggleCollapse}
                >
                  <span />
                  <span />
                </button>
              </Col>
            </Row>
          </div>
          <NavItems
            closeCollapse={closeCollapse}
            isCollapsed={isSidebarCollapsed}
          />
        </Collapse>
      </Container>
    </Navbar>
  );
};

SidebarComponent.propTypes = {
  logo: PropTypes.shape({
    innerLink: PropTypes.string,
    outterLink: PropTypes.string,
    imgSrc: PropTypes.string.isRequired,
    imgAlt: PropTypes.string.isRequired,
  }),
};
